import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1bd377b4"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["width", "height", "spin", "rtl"]
const _hoisted_2 = ["fill"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: _ctx._width,
    height: _ctx._height,
    spin: _ctx.spin,
    rtl: _ctx.rtl,
    viewBox: "0 0 14 14",
    preserveAspectRatio: "xMidYMid meet",
    fill: "",
    role: "presentation",
    ref: "host"
  }, [
    _createElementVNode("g", null, [
      _createElementVNode("path", {
        "data-follow-fill": "#BCBCBC",
        "fill-rule": "evenodd",
        d: "M7 14A7 7 0 1 1 7 0a7 7 0 0 1 0 14Zm.529-4.466c.15.14.23.337.223.541a.754.754 0 0 1-.234.552.795.795 0 0 1-.551.213.76.76 0 0 1-.553-.224.734.734 0 0 1-.223-.54c0-.224.074-.404.223-.542a.75.75 0 0 1 .553-.213.76.76 0 0 1 .562.212v.001Zm1.284-5.86c.426.37.638.88.638 1.518 0 .52-.138.955-.404 1.295-.096.116-.392.392-.89.827-.203.17-.352.362-.447.552a1.42 1.42 0 0 0-.17.701v.18H6.403v-.18c0-.392.064-.732.213-1.008.139-.297.541-.732 1.2-1.316l.18-.202c.192-.245.298-.5.298-.775 0-.372-.106-.658-.308-.871-.212-.212-.521-.318-.903-.318-.478 0-.828.148-1.04.456-.192.255-.287.616-.287 1.083H4.64c0-.776.223-1.38.67-1.826.445-.457 1.061-.68 1.846-.68.68 0 1.233.18 1.656.563Z",
        fill: _ctx._fill
      }, null, 8, _hoisted_2)
    ])
  ], 8, _hoisted_1))
}